import React from 'react';

export const TermsAndConditions =
        <>
            <p>TheAppBuilder Ltd – Terms of Service</p>

            <p>Thank you for choosing TheAppBuilder. These Terms of Service, together with the Services Order Form, set out the terms and conditions on which TheAppBuilder Ltd provides its subscription software services and professional services. Please read this document carefully.</p>

            <p>1. Definitions</p>

            <p>1.1. Except to the extent expressly provided otherwise, in these Terms of Service:</p>

            <p>“Account” means an account enabling a Client Administrative User to access and use the Hosted Services (including accounts for different types of Client Administrative User with varying access privileges);</p>

            <p>“Affiliate” means an entity that Controls, is Controlled by, or is under common Control with the relevant entity;</p>

            <p>“Agreement” means the agreement between the Provider and the Client for the provision of Services, comprising one or more Services Order Forms, these Terms of Service, and their respective annexes and schedules;</p>

            <p>“Business Day” means any weekday other than a bank or public holiday in England;</p>

            <p>“Business Hours” means the hours of 09:00 to 17:00 GMT/BST on a Business Day;</p>

            <p>“CCN” means a change control notice issued in accordance with Clause 10;</p>

            <p>“CCN Consideration Period” means the period of 10 Business Days following the receipt by a party of the relevant CCN from the other party;</p>

            <p>“Change” means any change to the scope of the Services;</p>

            <p>“Charges” means all of the amounts specified in the relevant Services Order Form for the Services;</p>

            <p>“Client” means the person or entity identified as such on the Services Order Form;</p>

            <p>“Client Administrative User” means any and all persons, whether or not employees of the Client, authorised by the Client to use the Platform and/or Hosted Services via an Account;</p>

            <p>“Client Content” means all content (including information, data, articles, documents, brochures, presentations, pictures, images, videos, audio visual works, other informational materials and any comments) provided to the Provider by the Client in connection with the Services; uploaded to or stored on the Platform by the Client; transmitted by the Platform at the instigation of the Client; supplied by the Client to the Provider for uploading to, transmission by or storage on the Platform; or generated by the Platform as a result of the use of the Hosted Services by the Client;</p>

            <p>“Client Indemnity Event” has the meaning given to it in Clause 17.5;</p>

            <p>“Client Personal Data” means any Personal Data that is processed by the Provider as a processor on behalf of the Client in the course of providing the Services, as described more fully in Schedule 6 (Data processing information);</p>

            <p>“Client Systems” means the hardware and software systems of the Client that interact with, or may reasonably be expected to interact with, the Hosted Services;</p>

            <p>“Confidential Information” means:</p>

            <p>(a) any information disclosed directly or indirectly by one party (the “disclosing party”) to the other party (the “ recipient”) at any time before the termination of the Agreement (whether disclosed in writing, orally or otherwise) that at the time of disclosure:</p>

            <p>(i) was marked or described as “confidential”; or</p>

            <p>(ii) should have been reasonably understood by the recipient to be confidential; and</p>

            <p>(b) the Client Content (which shall be the Confidential Information of the Client; and</p>

            <p>(c) the terms of the Agreement (which shall be the Confidential Information of the Provider);</p>

            <p>“Control” means the legal power to control (directly or indirectly) the management of an entity (and “Controlled” should be construed accordingly);</p>

            <p>“Created App(s)” means any mobile software application(s) created by the Client using the Hosted Services, with or without assistance from the Provider;</p>

            <p>“Customization” means a customization of the Hosted Services by the Provider for the Client, whether made through the development, configuration or integration of software or otherwise;</p>
        </> 